import {Component, OnInit} from '@angular/core';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import {WindowRefService} from "../../../helpers/windowref.service";


@Component({
    selector: 'app-create-account-in-mb',
    templateUrl: './create-account-in-mb.html',
    styleUrls: ['./create-account-in-mb.scss'],
    standalone: false
})

export class CreateAccountInMb implements OnInit {

  page: string | undefined;

  constructor(public dialogConfig: DynamicDialogConfig, private winRef: WindowRefService) { }

  async ngOnInit(): Promise<void> {
    this.page = this.dialogConfig?.data;
  }

  get platformLabel(): string {
    if (this.page === 'tiktok') {
      return 'TikTok';
    }

    if (this.page === 'google' || this.page === 'youtube') {
      return 'Google';
    }

    return 'Microsoft';
  }

  get couponAmount(): string {
    if (this.page === 'tiktok') {
      return '$10,000';
    }

    if (this.page === 'google' || this.page === 'youtube') {
      return '$500';
    }

    return '$1,000';
  }

  goToMediaBlast() {
    const campaign = this.page === "microsoft" ? "microsoft_create_account" : "create_account"
    this.winRef.navigate(`https://www.adcore.com/technologies/media-blast/?utm_source=couponer&utm_medium=referral&campaign=${campaign}`);
  }
}
